// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__nBQcb","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2dU71","obliqueLine":"membershipbadge_obliqueLine__13Ssq"};